import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const InboundDeliveriesCountQuery = graphql(/* GraphQL */ `
  query inboundDeliveriesCount(
    $plannedDeliveryDateFilter: DateTime
    $plannedDeliveryDateFilterMatch: DateTimeFilterMatchEnum
  ) {
    countInboundDeliveries(
      plannedDeliveryDateFilter: $plannedDeliveryDateFilter
      plannedDeliveryDateFilterMatch: $plannedDeliveryDateFilterMatch
    )
  }
`);
